import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
// import axios from 'axios'
import {OPEN_MODAL, OPEN_FRAME, OPEN_MODAL_VIDEO, OPEN_MODAL_DIALOG, OPEN_POPUP_LOCATE_CITY, OPEN_SUBSCRIPTION_STATUS} from './actionTypes'
// import {CityRedirect} from '../getCities/city-redirect'
// import _OffCanvasSlide from '../../utils/off-canvas-slide'

const useActions = () => {
  const dispatch = useDispatch()
  const openSlide = useCallback(
    status => {
      dispatch({
        type: OPEN_MODAL,
        open: status,
      })
    },
    [dispatch]
  )

  return {openSlide}
}

export default useActions


export const useFrameActions = () => {
  const dispatch = useDispatch()

  const openFrame = useCallback(
    status => {
      dispatch({
        type: OPEN_FRAME,
        open: status,
      })
    },
    [dispatch]
  )

  return {openFrame}
}

export const useModalVideoActions = () => {
  const dispatch = useDispatch()

  const openModalVideo = useCallback(
    status => {
      dispatch({
        type: OPEN_MODAL_VIDEO,
        payload: status,
      })
    },
    [dispatch]
  )

  return {openModalVideo}
}

export const useModalDialogActions = () => {
  const dispatch = useDispatch()

  const openModalDialog = useCallback(
    status => {
      dispatch({
        type: OPEN_MODAL_DIALOG,
        payload: status,
      })
    },
    [dispatch]
  )

  return {openModalDialog}
}

export const usePopupLocateCityActions = () => {
  const dispatch = useDispatch()

  const openPopupLocateCity = useCallback(
    status => {
      dispatch({
        type: OPEN_POPUP_LOCATE_CITY,
        payload: status,
      })
    },
    [dispatch]
  )

  return {openPopupLocateCity}
}

export const useSubscriptionStatusActions = () => {
  const dispatch = useDispatch()

  const openSubscriptionStatus = useCallback(
    status => {
      dispatch({
        type: OPEN_SUBSCRIPTION_STATUS,
        payload: status,
      })
    },
    [dispatch]
  )

  return {openSubscriptionStatus}
}